module.exports = __webpack_public_path__ + "static/media/bowoot_green_icon.c5c9ae96.png";